import React from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import TextField from '@mui/material/TextField';
import { useSnackbar } from 'notistack';
import SentimentDissatisfiedIcon from '@mui/icons-material/SentimentDissatisfied';
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';
import FormControl from '@mui/material/FormControl';
import InputLabel from '@mui/material/InputLabel';
import { PayPalButtons, usePayPalScriptReducer } from "@paypal/react-paypal-js";
import TokenService from '../../services/TokenService';

export default function UnscheduleReasonModal(props) {
    const [isLoading, setIsLoading] = React.useState(false);
    const handleClose = () => {
        props.Close('');
    };
    const [{ isResolved }, dispatch] = usePayPalScriptReducer();
    function isTest() {
        if (window.location.href.indexOf('localhost') > -1) {
            return true;
        }
        else if (window.location.href.indexOf('test.sipzee.com') > -1) {
            return true;
        }
        else {
            return false;
        }
    }

    return (<div>
        <Dialog
            open={true}
            onClose={handleClose}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
        >
            <DialogTitle id="alert-dialog-title">
                <div>Payment</div>
            </DialogTitle>
            <DialogContent>
                <div>
                    {isLoading ? 
                        <div>
                            Loading
                        </div>
                    :


                        <PayPalButtons createOrder={(data, actions) => {
                            return actions.order.create({
                                purchase_units: [
                                    {
                                        amount: {
                                            currency_code: 'USD',
                                            value: parseFloat(props.PickupRequest.RecyclerPurchaseCost)
                                        }
                                    },
                                ],
                                application_context: {
                                    shipping_preference: 'NO_SHIPPING'
                                }
                            }).then((orderId) => {
                                // Your code here after create the order
                                console.log('actions.order.create: orderId=' + orderId)
                                return orderId;
                            });
                        }}
                            onApprove={(data, actions) => {
                                return actions.order.capture().then((details) => {
                                    console.log('payment completed: ' + details.purchase_units[0].payments.captures[0].id);
                                    props.onPaymentCompleted(props.PickupRequest, details);


                                })
                            }} />
                    }
                </div>

            </DialogContent>
            <DialogActions>
                <div style={{ display: 'flex', justifyContent: 'space-between', width: '100%' }}>
                    <Button onClick={props.Close}>
                        Cancel
                    </Button>
                </div>
            </DialogActions>
        </Dialog>
    </div>
    );
}